// SaveButton.tsx
import React, {useCallback, useMemo, useState} from "react";
import {View} from "react-native";
import {ButtonType} from "../theme";
import {Button} from "../components";
import useAuth from "../contexts/Auth/useAuth";
import {useAppContext} from "../contexts/AppContext";
import {savePassportToAws} from "../utils/aws.utils";
import {addErrorEntry} from "../utils/errorFormHandlers";
import {Storage} from "../utils/Storage";
import {RasaUtils} from "../utils/Rasa.utils";
import {refreshIdTokenIfNeeded} from "../utils/cognitoAuth";
import {RASA_HOST} from "../../constants";


interface SaveButtonProps {
    disable: boolean;
    onSave: () => void; // Function passed as a parameter
}



const SaveButton: React.FC<SaveButtonProps> = ({onSave, disable}) => {
    const {setErrorItems, errorItems, saveStatus, setSaveStatus} = useAppContext();
    const {passportData, setPassportData} = useAuth();
    const {user, profileMoods, setProfileMoods} = useAuth();
    const [loading, setLoading] = useState(false);

    const rasaUtils = useMemo(() => new RasaUtils(RASA_HOST), [RASA_HOST]);

    const onSubmit = useCallback(async () => {
        setLoading(true);

        try {
            if (onSave) {
                await onSave();
            }
            if (user?.username && user?.token.jwtToken) {
                await savePassportToAws({
                    username: user.username,
                    jwtToken: user.token.jwtToken,
                    setProfileMoods,
                    setPassportData,
                });
            }

  //          let data = await Storage.getStorage();

            await Storage.setValue("form_changed", true);

            const idToken = await refreshIdTokenIfNeeded();
            const _data = await Storage.getStorage();
            const slotArray = await RasaUtils.buildRasaContextSlots(_data.sub || "XXX", _data.email  || "XXX", idToken || "");
            let res = await rasaUtils.updateRasaContext(_data.sub || "XXX", slotArray, idToken || "");

            setSaveStatus(true);

        } catch (error: any) {
            console.log("error:" + JSON.stringify(error));
            const newErrors = addErrorEntry(errorItems, {
                key: "global",
                message: "Sorry, data can't be persisted\nare you properly connected?\nIf so, please try to log out and in again",
                tab: "Share"
            });
            setErrorItems(newErrors); // Update the state with new errors


        } finally {
            setLoading(false);
        }

        //await saveToAws();

        // add all the state values used in the callback as its dependencies
    }, [user?.token]);

    return (
      <View
        style={{
            paddingTop: 20,
            justifyContent: "center",
            alignItems: "center",
        }}
      >
          <Button
            title={disable ? "Saved" : "Save"}
            disabled={disable}
            onPress={onSubmit}
            loading={loading}
            variant={ButtonType.secondary}
          />
      </View>
    );
};

export default SaveButton;
